export default __webpack_public_path__ + "static/media/doi.70dd1a75.png";